import { createSlice } from '@reduxjs/toolkit';

export const SLICE_NAME = 'exampleSlice';

export type ExampleSliceSliceState = Record<string, unknown>;

const initialState: ExampleSliceSliceState = {};

export const exampleSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {},
});

export default exampleSlice.reducer;
